// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"1d78b573","862":"be4af243"}[chunkId] + ".chunk.css";
};